import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
import Typography from '../Typography';
var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-161721h"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 32px 32px 16px 32px;\n  flex: 0 0 auto;\n\n  &.sizeLarge {\n    padding: 48px 48px 16px 48px;\n  }\n"], ["\n  margin: 0;\n  padding: 32px 32px 16px 32px;\n  flex: 0 0 auto;\n\n  &.sizeLarge {\n    padding: 48px 48px 16px 48px;\n  }\n"])));
var DialogTitle = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      paddingSize = _a.paddingSize,
      _b = _a.size,
      size = _b === void 0 ? paddingSize || 'normal' : _b,
      disableTypography = _a.disableTypography,
      children = _a.children,
      otherProps = __rest(_a, ["className", "paddingSize", "size", "disableTypography", "children"]);

  var rootClassName = classnames("size".concat(capitalize(size)), className);
  return _jsx(Root, __assign({
    className: rootClassName,
    ref: ref
  }, otherProps, {
    children: disableTypography ? children : size === 'normal' ? _jsx(Typography, __assign({
      variant: "h4",
      weight: "semiBold"
    }, {
      children: children
    })) : _jsx(Typography, __assign({
      variant: "h3",
      weight: "semiBold"
    }, {
      children: children
    }))
  }));
});
export default React.memo(DialogTitle);
var templateObject_1;